// Base
import React, { forwardRef } from "react";
import PropTypes from "prop-types";

// Styles
import styles from "./Price.scss";
import PriceText from "./PriceText";

export const Price = forwardRef((props, ref) => {
  const {
    tag,
    prefix,
    value,
    currency,
    locales,
    suffix,
    variants,
    fractionDigits,
    ...restProps
  } = props;

  const numberOfFractionDigitsToShow =
    fractionDigits || (parseFloat((value % 1).toFixed(2)) !== 0 ? 2 : 0);

  const formatter = new Intl.NumberFormat(locales, {
    style: "currency",
    currency,
    minimumFractionDigits: numberOfFractionDigitsToShow,
    maximumFractionDigits: numberOfFractionDigitsToShow,
  });

  const correctValue = formatter.format(value);

  let parsedVariants = variants;

  if (!variants) {
    parsedVariants = styles.price;
  }

  if (typeof parsedVariants !== "string") {
    parsedVariants = variants.join(" ");
  }

  const CustomTag = tag;

  return (
    <CustomTag ref={ref} className={parsedVariants} {...restProps}>
      {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
      {prefix && <span className={styles.prefix}>{prefix} </span>}

      <span className={styles.value}>{correctValue}</span>

      {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
      {suffix && <span className={styles.suffix}> {suffix}</span>}
    </CustomTag>
  );
});

// Props
Price.propTypes = {
  fractionDigits: PropTypes.number,
  tag: PropTypes.string,
  prefix: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  currency: PropTypes.string,
  locales: PropTypes.string,
  suffix: PropTypes.string,
  variants: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

Price.defaultProps = {
  fractionDigits: undefined,
  tag: "p",
  prefix: undefined,
  currency: "EUR",
  locales: "de-DE",
  suffix: undefined,
  variants: "",
};

Price.Variant = {
  highlight: styles.highlight,
  brand: styles.brand,
  benefit: styles.benefit,
  large: styles.large,
  scaled: styles.scaled,
  offering: styles.offering,
  inlineBlock: styles.inline_block,
  currentColor: styles.currentColor,
  currentFont: styles.currentFont,
  text: styles.as_text,
};

Price.Text = PriceText;

Price.displayName = "Price";

export default Price;
